import DeleteChecklistTemplateErrorDialogCtrl from "./delete_checklist_template_error_dialog.controller";
import dialogTemplate from "./delete_checklist_template_error_dialog.html";

export default function DeleteChecklistTemplateErrorDialogConfig(
    $mdDialogProvider
) {
    "ngInject";

    $mdDialogProvider.addPreset("deleteChecklistTemplateError", {
        methods: ["locals"],
        options: function () {
            return {
                controller: DeleteChecklistTemplateErrorDialogCtrl,
                controllerAs: "dialog",
                templateUrl: dialogTemplate,
                bindToController: true,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: true,
                hasBackdrop: true,
            };
        },
    });
}
